export const spacing = {
  space: {
    m: 24,
  },
};
